import classNames from 'classnames'
import React, { useEffect, useRef, useState } from 'react'

import { useForm, Controller } from 'react-hook-form'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import Slider, { Settings } from 'react-slick'

import { isMobile } from 'react-device-detect'

import { useNavigate } from 'react-router-dom'
import LazyVideo from 'pages/global/components/\bLazyVideo'
import { langList, videoTextList } from 'pages/global/common'

export const GlobalPage = () => {
  const PRODUCT_NAME_PATTERN = /^[^<>\uD800-\uDFFF]*$/

  const navigate = useNavigate()
  const [currentSlide, setCurrentSlide] = useState(0)
  const [successModal, setSuccessModal] = useState(false)
  const [limitModal, setLimitModal] = useState(false)

  const [isVideoDivOpen, setVideoDivOpen] = useState<boolean[]>(
    new Array(10).fill(false)
  )
  const [videoIdx, setVideoIdx] = useState(0)
  const sliderRef = useRef<any>(null)

  const handleVideoClick = (index: number) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index) // 클릭한 비디오의 인덱스로 슬라이드 이동
    }
  }

  const handleVideoDivOpen = (index: number) => {
    // 해당되는 index의 bool을 교체해줘야해
    const updateVideoDivOpen = isVideoDivOpen.map((el, idx) =>
      idx === index ? !el : false
    )
    setVideoDivOpen(updateVideoDivOpen)
  }

  const settings = {
    className: 'center',
    centerMode: true,
    centerPadding: '60px',
    infinite: true,
    speed: 500,
    slidesToShow: 9,
    slideToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 10000,
    initialSlide: 3,
    afterChange: (current: number) => {
      setCurrentSlide(current)
    },
    responsive: [
      {
        breakpoint: 720,
        settings: {
          className: 'center',
          centerMode: true,
          infinite: true,
          centerPadding: '110px',
          slidesToShow: 1,
          slideToScroll: 1,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 10000,

          afterChange: (current: number) => setCurrentSlide(current),
        },
      },
      {
        breakpoint: 1280,
        settings: {
          className: 'center',
          centerMode: true,
          infinite: true,
          centerPadding: '70px',
          slidesToShow: 5,
          slideToScroll: 1,
          speed: 500,
          autoplay: true,
          autoplaySpeed: 10000,
          afterChange: (current: number) => setCurrentSlide(current),
        },
      },
    ],
  }

  const handleButtonClick = (id: string) => {
    const inputElement = document.getElementById(id) as HTMLInputElement
    if (inputElement) {
      inputElement.click()
    }
  }

  useEffect(() => {
    const slides = document.querySelectorAll('.slick-slide')

    slides.forEach((slide: any) => {
      if (slide.classList.contains('slick-slide')) {
        slide.style.opacity = '0.3'
        const videoElement = slide.querySelector('video')
        if (videoElement) {
          videoElement.controls = false
        }
      }
      if (slide.classList.contains('slick-current')) {
        slide.style.opacity = '1'
        const videoElement: HTMLVideoElement = slide.querySelector('video')

        if (videoElement) {
          const index = videoElement.getAttribute('data-index')
          setVideoIdx(Number(index))
          videoElement.controls = true
          handleVideoDivOpen(Number(index))
        }
      }
    })
  }, [currentSlide])

  return (
    <div className="md:w-full w-[375px] flex flex-col items-center ">
      <div className="md:w-[816px] flex flex-col items-center justify-center gap-4  py-8 ">
        <p
          className="font-[800] md:text-[48px] text-[32px]"
          style={{
            background: 'linear-gradient(90deg, #6095FF, #D512E7)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}
        >
          {' '}
          {'AI Video Generator'}
        </p>

        {/* <p className="font-bold text-[24px] md:w-full w-[343px] text-center">
          subtitle
        </p> */}
      </div>
      <div className="slider-container md:w-[calc(100%)] md:h-[calc(100%)] w-[100%]  my-4">
        <Slider ref={sliderRef} {...settings}>
          {new Array(10).fill(0).map((_, index) => (
            <div
              key={`video_${index}`}
              className="video-container flex flex-col cursor-pointer"
              onClick={() => {
                setVideoIdx(index)
                handleVideoClick(index)
              }}
            >
              <LazyVideo
                index={index}
                src={`https://s3.ap-northeast-2.amazonaws.com/pub.angelleague.io/fast_cut/vivideo/${index}.mp4`}
                className="custom-video"
                width="150px"
                height="226px"
                muted
                autoPlay
                loop={true}
              />
              <div
                className="flex items-center gap-1 cursor-pointer"
                onClick={() => {
                  setVideoIdx(index)
                  handleVideoClick(index)
                  handleVideoDivOpen(index)
                }}
              >
                <span
                  className={classNames('text-[14px]', {
                    'text-main': isVideoDivOpen[index],
                  })}
                >
                  View Idea
                </span>
                <img
                  src="assets/image/icon/arrow.png"
                  alt="arrow"
                  className={`w-[8px] h-[6px]  transition-transform duration-500 ${
                    isVideoDivOpen[index] ? '' : 'rotate-180'
                  }`}
                />
              </div>
            </div>
          ))}
        </Slider>
      </div>
      {isVideoDivOpen[videoIdx] && (
        <div className="bg-[#2E343D] md:w-[816px] min-h-[160px] text-white p-4 md:rounded-[10px] mb-10">
          <div className="w-full min-h-[128px] bg-black p-4 rounded-[6px] flex flex-col gap-1">
            {/* <p>{t(`videoInfo.items.${videoIdx}.idea`)}</p> */}
            {/* <p>{t(`videoInfo.items.${videoIdx}.title`)}</p> */}
            <p>{videoTextList[videoIdx]}</p>
          </div>
        </div>
      )}

      <form>
        <div className="flex flex-col gap-5 md:bg-white bg-[#F6F8FB]">
          <div
            className={classNames(
              'idea md:shadow-main bg-white h-[292px] md:rounded-[40px]  md:p-10 px-4 py-5',
              {
                'border-[1px] border-[#EEF1F7]': !isMobile,
                'border-y-[1px] border-[#EEF1F7]': isMobile,
              }
            )}
          >
            <div className="flex flex-col mb-4 ">
              <p className="font-bold text-[24px]">Idea (or Story)</p>
              <p className="text-main text-[14px]">
                Enter a brief idea or story you'd like to turn into a video.
              </p>
            </div>
            <div className=" relative">
              <textarea
                className={classNames(
                  'resize-none w-full bg-[#F9F9FB] h-[146px] rounded-[10px] p-4'
                )}
                placeholder={'Enter Your Idea or Story'}
                maxLength={2000}
              ></textarea>
              <span className=" absolute text-[#8F929B] bottom-4 right-3">
                (0/2000)
              </span>
            </div>
          </div>
          <div
            className={classNames(
              'Title md:shadow-main bg-white h-[247px] md:rounded-[40px] md:p-10 px-4 py-5 ',
              {
                ' border-[1px] border-[#EEF1F7]': !isMobile,
                ' border-y-[1px] border-[#EEF1F7]': isMobile,
              }
            )}
          >
            <div className="flex flex-col mb-4">
              <p className="font-bold text-[24px]"> Title</p>
              <p className="text-main text-[14px]">
                {'Enter a title that fits your video.'}
              </p>
            </div>
            <div className=" relative">
              <textarea
                className={classNames(
                  'resize-none w-full bg-[#F9F9FB] h-[101px] rounded-[10px] p-4'
                )}
                placeholder={'Enter a Title for Your Video'}
                maxLength={100}
              ></textarea>
            </div>
          </div>
          <div
            className={classNames(
              'product md:shadow-main bg-white  md:rounded-[40px]  md:p-10 px-4 py-6 flex flex-col gap-4',
              {
                'border-[1px] border-[#EEF1F7]': !isMobile,
                'border-y-[1px] border-[#EEF1F7]': isMobile,
              }
            )}
          >
            <div className="flex md:flex-row flex-col justify-between gap-4">
              <label
                className={classNames(
                  ' relative flex md:justify-start  md:w-[50%] h-[60px] border-[1px] border-[#D9DEE8] items-center rounded-[10px] gap-4 cursor-pointer px-6'
                )}
              >
                <div
                  className={`w-[20px] h-[20px] rounded-full border-2  flex items-center justify-center `}
                ></div>
                <span className="flex flex-col font-bold text-[18px]">
                  Use Stock Videos
                </span>
              </label>
              <label
                className={classNames(
                  ' relative flex  md:w-[50%] h-[60px] border-[1px] border-[#D9DEE8] items-center rounded-[10px] gap-4 cursor-pointer  px-6'
                )}
              >
                <input type="checkbox" className="sr-only" />
                <div
                  className={`w-[20px] h-[20px] rounded-full border-2  flex items-center justify-center `}
                ></div>
                <span className="font-bold text-[18px]">Upload Images</span>
              </label>
            </div>
            {/* {watch('sourceType') === 'image' && (
              <>
                <div>
                  <p className="text-[14px] text-main">
                    {t(
                      'home.The 4 uploaded images will be used in order in the clip.'
                    )}
                  </p>
                </div>

                <div className="flex flex-col gap-4">
                  {isMobile ? (
                    <>
                      {' '}
                      {new Array(4).fill(0).map((el, index) => (
                        <div className="flex flex-col " key={index}>
                          <p className="font-bold">
                            Upload {index + 1}
                            {ordinalNumber[index]} Image
                          </p>

                          <div className="flex items-center justify-end">
                            {imgs[index] ? (
                              <span className=" text-right mr-4">
                                {imgs[index]!.name}
                              </span>
                            ) : (
                              <span className="text-[#B6BBC6] mr-4">
                                {t('home.No file selected')}
                              </span>
                            )}

                            <button
                              onClick={() =>
                                handleButtonClick(`file-input-${index}`)
                              }
                              type="button"
                              className="w-[124px] h-[36px] flex items-center bg-[#6B8ACB] justify-center rounded-full "
                            >
                              <img
                                src="assets/image/icon/file.png"
                                alt="file"
                                width="17px"
                              />
                              <span className="text-[white] text-[14px] ml-[6px]">
                                {t('home.Select file')}
                              </span>
                            </button>
                            <input
                              id={`file-input-${index}`}
                              type="file"
                              accept=".jpg,.jpeg,.png"
                              multiple={false}
                              className="hidden"
                              onChange={(e) => handleFileChange(index, e)}
                            />
                          </div>
                        </div>
                      ))}
                    </>
                  ) : (
                    <>
                      {new Array(4).fill(0).map((el, index) => (
                        <div
                          className="flex items-center justify-between"
                          key={index}
                        >
                          <p className="font-bold">
                            Upload {index + 1}
                            {ordinalNumber[index]} Image
                          </p>

                          <div className="flex items-center">
                            {imgs[index] ? (
                              <span className=" text-right mr-4">
                                {imgs[index]!.name}
                              </span>
                            ) : (
                              <span className="text-[#B6BBC6] mr-4">
                                {t('home.No file selected')}
                              </span>
                            )}

                            <button
                              onClick={() =>
                                handleButtonClick(`file-input-${index}`)
                              }
                              type="button"
                              className="w-[124px] h-[36px] flex items-center bg-[#6B8ACB] justify-center rounded-full "
                            >
                              <img
                                src="assets/image/icon/file.png"
                                alt="file"
                                width="17px"
                              />
                              <span className="text-[white] text-[14px] ml-[6px]">
                                {t('home.Select file')}
                              </span>
                            </button>
                            <input
                              id={`file-input-${index}`}
                              type="file"
                              accept=".jpg,.jpeg,.png"
                              multiple={false}
                              className="hidden"
                            />
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </>
            )} */}
          </div>
          <div
            className={classNames(
              'language md:shadow-main bg-white min-h-[510px] md:rounded-[40px]  md:p-10 px-4 py-6',
              {
                'border-[1px] border-[#EEF1F7]': !isMobile,
                'border-y-[1px] border-[#EEF1F7]': isMobile,
              }
            )}
          >
            <div className="flex flex-col mb-4">
              <p className="font-bold text-[24px]">Language</p>
              <p className="text-main text-[14px]">
                What language would you like your video in?
              </p>
            </div>
            <div className="grid md:grid-cols-2 grid-cols-1  gap-y-4 gap-x-4 ">
              {langList.map((el, index) => (
                <label
                  className={classNames(
                    ' relative flex md:w-[360px] w-[343px] h-[60px] border-[1px] border-[#D9DEE8] items-center rounded-[10px] gap-4 cursor-pointer px-6 font-bold'
                  )}
                >
                  <input type="checkbox" className="sr-only" />
                  <div
                    className={`w-[20px] h-[20px] rounded-full border-2  flex items-center justify-center`}
                  ></div>
                  <span>{el.name}</span>
                </label>
              ))}
            </div>
          </div>
          <p className="w-full text-center text-[#8F929B] text-[14px]">
            FASTCUT AI can make mistakes. Check important info.
          </p>
          <div className="flex flex-col justify-center items-center py-4">
            <button
              className={classNames(
                'bg-[#D9DEE8] text-white w-[343px] h-[60px] font-[800] rounded-full '
              )}
            >
              Generate Video Clip
            </button>
          </div>
          <div className="flex flex-col justify-center items-center mb-10 ">
            <a
              className="text-main text-[14px]"
              href="https://forms.gle/gU4eojPtxdErKwm39"
              target="_blank"
              rel="noreferrer"
            >
              If you encounter any issues while using the service, please report
              them!
            </a>
          </div>
        </div>
      </form>
    </div>
  )
}
